<template>
  <div class="list">
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <!-- Ohne Recht gibt es nichts zu filtern: nur die Meldung des Servers über die ganze Breite -->
        <div v-if="!fehlermeldung" class="col-2">
          <div class="container-fluid">
            <head-menu-filter :col="12" class="d-xl-flex" :headline="$t('global.filter')"></head-menu-filter>

            <div class="row mb-2">
              <div class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <select v-model="filter.art" class="form-control">
                        <option value="">{{ $t("global.all") }}</option>
                        <option v-for="a in arten" :key="a.key" :value="a.key">{{ uebersetzt(uebersetze, a, "mehrzahl") }}</option>
                      </select>
                      <label>{{ $t("global.kind") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <select v-model="filter.ablauf" class="form-control">
                        <option value="">{{ $t("global.allworkflows") }}</option>
                        <option v-for="a in ablaeufe" :key="a.kennung" :value="a.kennung">{{ a.bezeichnung }}</option>
                      </select>
                      <label>{{ $t("global.workflow") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <date-picker v-model="filter.von" date-format="dd.mm.yy" :show-icon="true" />
                      <label>{{ $t("global.periodfrom") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <date-picker v-model="filter.bis" date-format="dd.mm.yy" :show-icon="true" />
                      <label>{{ $t("global.periodto") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <select v-model="filter.ergebnis" class="form-control">
                        <option v-for="e in ergebnisse" :key="e.key" :value="e.key">{{ uebersetzt(uebersetze, e) }}</option>
                      </select>
                      <label>{{ $t("global.result") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <select v-model="filter.ausloeser" class="form-control">
                        <option v-for="a in ausloeser" :key="a.key" :value="a.key">{{ uebersetzt(uebersetze, a) }}</option>
                      </select>
                      <label>{{ $t("global.trigger") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input v-model.trim="filter.id" class="form-control input" type="text" placeholder=" " />
                      <label>{{ $t("global.runid") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input v-model.trim="filter.code" class="form-control input" type="text" placeholder=" " />
                      <label>{{ $t("global.errorcode") }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button />
              </div>
            </div>
          </div>
        </div>

        <div :class="fehlermeldung ? 'col-12' : 'col-10'">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="`${$t('global.log')} · ${$t('global.controlsandinterfaces')}`"
              :gesamtanzahl="gesamtanzahl"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0 p-3">
                <div v-if="fehlermeldung" class="alert alert-danger mb-0">{{ fehlermeldung }}</div>
                <lauf-tabelle
                  v-else-if="bereit"
                  ref="tabelle"
                  :filter="parameter"
                  :felder="felder"
                  @geladen="gesamtanzahl = $event.gesamtanzahl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <lauf-ansicht />
  </div>
</template>

<script>
import AppApi from "@/api/AppApi";
import page from "@/mixins/Page";
import HeadMenu from "@/components/HeadMenu";
import HeadMenuFilter from "@/components/HeadMenuFilter";
import FilterSearchResetButton from "@/components/Buttons/FilterSearchResetButton";
import Navbar from "@/components/Navbar";
import DatePicker from "@/components/Datepicker";
import LaufAnsicht from "@/components/Lauf/LaufAnsicht.vue";
import LaufTabelle from "@/components/Lauf/LaufTabelle.vue";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import {
  ARTEN,
  AUSLOESER_FILTER as AUSLOESER,
  ERGEBNIS_FILTER as ERGEBNISSE,
  uebersetzt,
} from "@/components/Lauf/LaufTexte";

/** Die Filter im Standard, beim Laden und nach dem X */
function neuerFilter() {
  return { art: "", ablauf: "", von: "", bis: "", ergebnis: "alle", ausloeser: "alle", id: "", code: "" };
}

/**
 * Protokoll aller Läufe aller Abläufe (Konzept Steuerungen und Schnittstellen 9.4, Board „Protokoll“). Der
 * Query-Parameter lauf öffnet die Lauf-Ansicht des Laufs direkt, etwa aus einem Alarm (8.4). Ohne Recht zeigt
 * die Seite die Meldung des Servers. Kein Drucken und kein Export (Entscheid Sven Seiler, 21.10.2026).
 */
export default {
  name: "Protokoll",
  components: {
    Navbar,
    HeadMenu,
    HeadMenuFilter,
    DatePicker,
    LaufAnsicht,
    LaufTabelle,
    FilterSearchResetButton,
  },
  mixins: [page],
  data() {
    return {
      docsName: "protokoll",
      ablaeufe: [],
      bereit: false,
      fehlermeldung: null,
      gesamtanzahl: null,
      arten: ARTEN,
      ergebnisse: ERGEBNISSE,
      ausloeser: AUSLOESER,
      // filter: was in den Feldern steht; gesuchterFilter: womit zuletzt gesucht wurde (Suchen, Enter, Lupe)
      filter: neuerFilter(),
      gesuchterFilter: neuerFilter(),
      felder: ["zeitpunkt", "ablauf", "art", "ausloeser", "dauer", "ergebnis", "zusammenfassung", "fehler", "id"],
    };
  },
  computed: {
    // Titel im Browser-Tab über das Mixin Page („BX: Protokoll“)
    navbarTitel() {
      return this.$t("global.log");
    },
    /** Die zuletzt gesuchten Filter als Parameter für GET lauf/; ein geändertes Feld allein lädt nicht neu */
    parameter() {
      const f = this.gesuchterFilter;
      return {
        art: f.art,
        ablauf: f.ablauf,
        von: f.von,
        bis: f.bis,
        id: f.id,
        code: f.code,
        status: ERGEBNISSE.find((e) => e.key === f.ergebnis).status,
        ...AUSLOESER.find((a) => a.key === f.ausloeser).parameter,
      };
    },
  },
  watch: {
    // Auch wenn die Seite schon offen ist, etwa über „Im Protokoll öffnen“ aus der Lauf-Ansicht
    "$route.query.lauf"() {
      this.laufAusLinkOeffnen();
    },
  },
  created() {
    this.ablaeufeLaden();
  },
  mounted() {
    this.laufAusLinkOeffnen();
    // Lupe und X im Kopf der Filterspalte (HeadMenuFilter), wie in den Listen
    this.$bus.$on("searchWithFilter", this.suchen);
    this.$bus.$on("resetFilter", this.filterZuruecksetzen);
  },
  beforeDestroy() {
    this.$bus.$off("searchWithFilter", this.suchen);
    this.$bus.$off("resetFilter", this.filterZuruecksetzen);
  },
  methods: {
    uebersetzt,
    uebersetze(schluessel) {
      return this.$t(schluessel);
    },
    /**
     * Suchen, Enter oder Lupe: die Filter aus den Feldern übernehmen, wie in den übrigen Listen. Haben sie sich
     * geändert, lädt die Tabelle über ihren Watcher neu, sonst hier.
     */
    suchen() {
      const neu = { ...this.filter };
      if (JSON.stringify(neu) !== JSON.stringify(this.gesuchterFilter)) {
        this.gesuchterFilter = neu;
      } else if (this.$refs.tabelle) {
        this.$refs.tabelle.vonVorn();
      }
    },
    /** zurücksetzen oder X: alle Filter auf den Standard und neu suchen */
    filterZuruecksetzen() {
      this.filter = neuerFilter();
      this.suchen();
    },
    /** Die Abläufe für den Filter; ohne Recht kommt die Meldung des Servers statt der Tabelle */
    ablaeufeLaden() {
      AppApi.get("lauf/ablaeufe/", { redirectOnError: false })
        .then((response) => {
          this.ablaeufe = response.data;
          this.bereit = true;
        })
        .catch((e) => {
          if (e.response && e.response.status === 403) {
            this.fehlermeldung = e.response.data;
          } else {
            this.$notify(apiErrorToAlert(e));
          }
        });
    },
    laufAusLinkOeffnen() {
      const lauf = this.$route.query.lauf;
      if (lauf) this.$bus.$emit("lauf-ansicht-oeffnen", { lauf });
    },
  },
};
</script>
